class AddonOptionsEnhanced {
  constructor() {
    this.container = document.querySelector('.addon-options-enhanced');
    if (!this.container) return;

    this.checkboxes = this.container.querySelectorAll('.addon-checkbox');
    this.countElement = this.container.querySelector('.addon-count');
    this.totalElement = this.container.querySelector('.addon-total');
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateSummary();
  }

  bindEvents() {
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
      
      // Handle disabled state for out of stock items
      const card = checkbox.closest('.addon-card');
      const stockElement = card.querySelector('.addon-card__stock--unavailable');
      
      if (stockElement) {
        checkbox.disabled = true;
        card.classList.add('addon-card--disabled');
      }
    });
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    const card = checkbox.closest('.addon-card');
    
    // Add visual feedback
    if (checkbox.checked) {
      card.classList.add('addon-card--selected');
      this.animateSelection(card, true);
    } else {
      card.classList.remove('addon-card--selected');
      this.animateSelection(card, false);
    }
    
    this.updateSummary();
  }

  animateSelection(card, isSelected) {
    const checkIcon = card.querySelector('.addon-card__check');
    
    if (isSelected) {
      // Small bounce animation for selection
      checkIcon.style.transform = 'scale(1.2)';
      setTimeout(() => {
        checkIcon.style.transform = 'scale(1)';
      }, 200);
      
      // Subtle card animation
      card.style.transform = 'scale(1.02)';
      setTimeout(() => {
        card.style.transform = 'scale(1)';
      }, 200);
    }
  }

  updateSummary() {
    const selectedCheckboxes = Array.from(this.checkboxes).filter(cb => cb.checked);
    const count = selectedCheckboxes.length;
    
    // Calculate total price
    let totalPrice = 0;
    selectedCheckboxes.forEach(checkbox => {
      const price = parseFloat(checkbox.dataset.addonPrice) || 0;
      totalPrice += price;
    });

    // Update count text
    if (count === 0) {
      this.countElement.textContent = '0 selected';
    } else if (count === 1) {
      this.countElement.textContent = '1 selected';
    } else {
      this.countElement.textContent = `${count} selected`;
    }

    // Update total price (format as money)
    this.totalElement.textContent = `+$${(totalPrice / 100).toFixed(2)}`;

    // Add visual emphasis when items are selected
    const summary = this.container.querySelector('.addon-options__summary');
    if (count > 0) {
      summary.classList.add('addon-summary--active');
      this.animateTotalUpdate();
    } else {
      summary.classList.remove('addon-summary--active');
    }
  }

  animateTotalUpdate() {
    // Subtle animation for total update
    this.totalElement.style.transform = 'scale(1.1)';
    this.totalElement.style.fontWeight = '700';
    
    setTimeout(() => {
      this.totalElement.style.transform = 'scale(1)';
      this.totalElement.style.fontWeight = '600';
    }, 200);
  }

  // Method to get selected addon data (used by product form)
  getSelectedAddons() {
    return Array.from(this.checkboxes)
      .filter(cb => cb.checked)
      .map(cb => ({
        variantId: cb.dataset.variantId,
        title: cb.dataset.addonTitle,
        price: cb.dataset.addonPrice
      }));
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.addonOptionsEnhanced = new AddonOptionsEnhanced();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.addonOptionsEnhanced = new AddonOptionsEnhanced();
  });
} else {
  window.addonOptionsEnhanced = new AddonOptionsEnhanced();
}